import { render, staticRenderFns } from "./ProblemControlers.vue?vue&type=template&id=75d45b80&scoped=true&"
import script from "./ProblemControlers.vue?vue&type=script&lang=js&"
export * from "./ProblemControlers.vue?vue&type=script&lang=js&"
import style0 from "./ProblemControlers.vue?vue&type=style&index=0&id=75d45b80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d45b80",
  null
  
)

export default component.exports